module.exports = __webpack_public_path__ + "static/media/dotted_oval.97a0721f.svg";